import { Typography } from 'core/Typography';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import SectionWrapper from 'shared/SectionWrapper';

function Calculator() {
    return (
        <SectionWrapper>
            <div className="flex flex-col gap-[40px] lg-tablet:gap-[60px]">
                <div className="flex flex-col gap-[12px] mobile:gap-[16px] lg-tablet:gap-[24px]">
                    <Typography variant="h2">Калькулятор стоимости найма</Typography>
                    <Typography className="lg-tablet:max-w-8/12">
                        Чтобы продемонстрировать эффект использования TalentMind в измеряемых
                        значениях, мы разработали{' '}
                        <Link href="https://talentmind.ru/" target="_blank">
                            калькулятор стоимости
                        </Link>{' '}
                        кадровой ошибки. Он позволяет рассчитать реальные потери при найме
                        неподходящего сотрудника и помогает увидеть ROI от внедрения TalentMind.
                    </Typography>
                </div>
                <div className="aspect-[1400/587] relative">
                    <Image
                        fill
                        src={`/images/pic/talent-mind/calculator.png`}
                        alt={'Калькулятор стоимости найма'}
                        objectFit={'contain'}
                    />
                </div>
            </div>
        </SectionWrapper>
    );
}

export default Calculator;
